import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WyznaczAdresataResponse } from '../../models/wyznacz-adresata-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { WyznaczAdresataRequest } from '../../models/wyznacz-adresata-request';
import { ApplicationCode } from '../../enums/application_code';

@Injectable()
export class PocztaWewnApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/pocztaWewn';

  public wyznaczAdresataWgWojewodztwa(
    voivodeshipCode: string,
    obszarZSkod: string,
    kodTypuInstyt?: number,
  ): Observable<WyznaczAdresataResponse[]> {
    return this.#httpClient.post<WyznaczAdresataResponse[]>(
      `${this.#apiUrl}/wyznaczAdresataWgWojewodztwa`,
      {
        obszarZSkod: obszarZSkod,
        kodTypuInstyt: kodTypuInstyt,
        terytWojew: voivodeshipCode,
      } as WyznaczAdresataRequest,
      {
        withCredentials: true,
      },
    );
  }

  public wyznaczAdresataWgGminy(
    applicationCode: ApplicationCode,
    obszarZSkod: string,
    phrase: string,
  ): Observable<WyznaczAdresataResponse[]> {
    return this.#httpClient.post<WyznaczAdresataResponse[]>(
      `${this.#apiUrl}/wyznaczAdresataWgMiejscGmina`,
      {
        obszarZSkod: obszarZSkod,
        kodWniosku: applicationCode.replace('_', '-'),
        miejsceGmina: phrase,
      } as WyznaczAdresataRequest,
      {
        withCredentials: true,
      },
    );
  }
}
